/* Deluxe v2 bulk enquiry: pick products → quantity per size → quote list, serialized into the contact form. */
(function () {
  var root = document.querySelector('[data-v2-quote-builder]');
  var dataEl = document.querySelector('[data-v2-quote-data]');
  if (!root || !dataEl) return;
  var form = root.closest('form');
  var KEY = 'dfx_v2_quote';
  var MIN = (window.DFX_TRADE && +window.DFX_TRADE.minPairs) || 12;
  var T = window.DFX_QB_T || {};
  // Wording comes from the theme's language file (Edit default theme content → Dfx); English fallbacks below.
  function t(k, d, v) { var s = T[k] || d; if (v) Object.keys(v).forEach(function (n) { s = s.split('{' + n + '}').join(v[n]); }); return s; }
  var ranges;
  try { ranges = JSON.parse(dataEl.textContent); } catch (e) { return; }
  var byHandle = {};
  ranges.forEach(function (r) { r.items.forEach(function (p) { p.range = r.range; byHandle[p.h] = p; }); });

  var $ = function (s) { return root.querySelector(s); };
  var sel = $('[data-qb-product]'), chosen = $('[data-qb-chosen]'), img = $('[data-qb-img]'), titleEl = $('[data-qb-title]'), meta = $('[data-qb-meta]');
  var colourWrap = $('[data-qb-colour-wrap]'), colourSel = $('[data-qb-colour]');
  var sizesWrap = $('[data-qb-sizes-wrap]'), sizesEl = $('[data-qb-sizes]'), sizeLabel = $('[data-qb-size-label]');
  var addWrap = $('[data-qb-add-wrap]'), addBtn = $('[data-qb-add]'), subtotalEl = $('[data-qb-subtotal]');
  var listWrap = $('[data-qb-list-wrap]'), listEl = $('[data-qb-list]'), totalEl = $('[data-qb-total]'), hintEl = $('[data-qb-hint]'), errEl = $('[data-qb-err]');
  var field = form.querySelector('[data-qb-field]');
  var notes = form.querySelector('[data-v2-enquiry-items]');
  var notesLabel = form.querySelector('[data-qb-notes-label]');
  var pairsInput = form.querySelector('input[name="contact[Approximate pairs]"]');
  var rangeSel = form.querySelector('[data-v2-enquiry-range]');
  var notesLabelText = notesLabel ? notesLabel.firstChild.textContent : '';
  var notesPh = notes ? notes.placeholder : '';

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function load() { try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; } }
  function save() { try { localStorage.setItem(KEY, JSON.stringify(lines)); } catch (e) {} }
  function unit(p, n) { if (p && p.co) return n + ' ' + (n === 1 ? t('case', 'case') : t('cases', 'cases')); var shoe = !p || p.sl === 'UK size'; return n + ' ' + (shoe ? (n === 1 ? t('pair', 'pair') : t('pairs', 'pairs')) : (n === 1 ? t('item', 'item') : t('items', 'items'))); }
  function sum(q) { return Object.keys(q).reduce(function (n, k) { return n + (q[k] || 0); }, 0); }
  function sizeText(p, k) { return k === '_' ? (p && p.co ? t('cases_label', 'Cases') : t('qty_label', 'Qty')) : (p && p.sl === 'UK size' ? t('uk', 'UK') + ' ' + k : k); }

  var lines = load().filter(function (l) { return byHandle[l.h]; });
  var current = null;

  // Product select, grouped by range.
  ranges.forEach(function (r) {
    var g = document.createElement('optgroup'); g.label = r.range;
    r.items.forEach(function (p) { var o = document.createElement('option'); o.value = p.h; o.textContent = p.t + ' — ' + p.p; g.appendChild(o); });
    sel.appendChild(g);
  });

  function pick(handle, focusSize) {
    current = byHandle[handle] || null;
    sel.value = current ? current.h : '';
    chosen.hidden = colourWrap.hidden = sizesWrap.hidden = addWrap.hidden = !current;
    if (!current) return;
    if (current.img) { img.src = current.img; img.hidden = false; } else img.hidden = true;
    titleEl.textContent = current.t;
    meta.textContent = [current.b, current.range, current.p].filter(Boolean).join(' · ');
    colourWrap.hidden = !current.c.length;
    colourSel.innerHTML = current.c.map(function (c) { return '<option>' + esc(c) + '</option>'; }).join('');
    var sizes = current.s.length ? current.s : ['_'];
    sizeLabel.textContent = current.s.length ? (current.sl === 'UK size' ? t('how_many_uk', 'How many of each UK size?') : t('how_many_size', 'How many of each size?')) : (current.co ? t('how_many_cases', 'How many cases? (sold by the case; we’ll confirm case sizes)') : t('how_many', 'How many?'));
    sizesEl.innerHTML = sizes.map(function (s, i) {
      var id = 'qb-s-' + i;
      return '<div class="v2-qb__size"><label for="' + id + '">' + esc(sizeText(current, s)) + '</label>' +
        '<input id="' + id + '" type="number" inputmode="numeric" min="0" step="1" placeholder="0" data-size="' + esc(s) + '"></div>';
    }).join('');
    sizesEl.querySelectorAll('input').forEach(function (i) { i.addEventListener('input', updateSub); });
    updateSub();
    var f = focusSize && sizesEl.querySelector('input[data-size="' + (window.CSS && CSS.escape ? CSS.escape(focusSize) : focusSize) + '"]');
    if (f) f.focus();
  }

  function pending() {
    var q = {};
    sizesEl.querySelectorAll('input').forEach(function (i) { var v = Math.max(0, parseInt(i.value, 10) || 0); if (v) q[i.dataset.size] = v; });
    return q;
  }
  function updateSub() {
    var n = sum(pending());
    subtotalEl.textContent = t('selected', '{n} selected', { n: unit(current, n) });
    addBtn.disabled = !n;
  }

  function add() {
    if (!current) return false;
    var q = pending(); if (!sum(q)) return false;
    var colour = current.c.length ? colourSel.value : '';
    var line = lines.filter(function (l) { return l.h === current.h && l.c === colour; })[0];
    if (line) Object.keys(q).forEach(function (k) { line.q[k] = (line.q[k] || 0) + q[k]; });
    else lines.push({ h: current.h, c: colour, q: q });
    sizesEl.querySelectorAll('input').forEach(function (i) { i.value = ''; });
    updateSub(); render(); save();
    errEl.hidden = true;
    return true;
  }

  function render() {
    listWrap.hidden = !lines.length;
    var total = 0, pairs = 0, items = 0, cases = 0, rangeSet = {};
    listEl.innerHTML = lines.map(function (l, idx) {
      var p = byHandle[l.h], n = sum(l.q); total += n; rangeSet[p.range] = 1;
      if (p.co) cases += n; else if (p.sl === 'UK size') pairs += n; else items += n;
      var sizes = Object.keys(l.q).map(function (k) { return esc(sizeText(p, k)) + ' × ' + l.q[k]; }).join(', ');
      return '<li class="v2-qb__line">' + (p.img ? '<img src="' + esc(p.img) + '" alt="" width="56" height="56">' : '') +
        '<div class="v2-qb__lineinfo"><strong>' + esc(p.t) + '</strong>' + (l.c ? '<span>' + esc(l.c) + '</span>' : '') +
        '<span>' + sizes + '</span></div><span class="v2-qb__linecount">' + unit(p, n) + '</span>' +
        '<span class="v2-qb__lineactions"><button type="button" data-edit="' + idx + '">' + esc(t('edit', 'Edit')) + '</button>' +
        '<button type="button" data-remove="' + idx + '" aria-label="' + esc(t('remove', 'Remove')) + ' ' + esc(p.t) + '">' + esc(t('remove', 'Remove')) + '</button></span></li>';
    }).join('');
    var parts = [];
    if (pairs) parts.push(unit({ sl: 'UK size' }, pairs));
    if (items) parts.push(unit({ sl: '' }, items));
    if (cases) parts.push(unit({ co: true }, cases));
    var totalText = parts.join(' + ');
    totalEl.textContent = t('total', 'Total: {n}', { n: totalText });
    var ok = cases > 0 || pairs + items >= MIN;
    hintEl.className = 'v2-qb__hint' + (ok ? ' is-ok' : '');
    hintEl.textContent = ok ? t('qualifies', 'This order qualifies for wholesale pricing ({min}+ pairs or case quantities).', { min: MIN })
      : t('add_more', 'Add {n} more to reach wholesale pricing ({min}+ pairs). Smaller orders are welcome too.', { n: MIN - pairs - items, min: MIN });
    listEl.querySelectorAll('[data-remove]').forEach(function (b) { b.addEventListener('click', function () { lines.splice(+b.dataset.remove, 1); render(); save(); }); });
    listEl.querySelectorAll('[data-edit]').forEach(function (b) {
      b.addEventListener('click', function () {
        var l = lines.splice(+b.dataset.edit, 1)[0]; render(); save();
        pick(l.h); if (l.c) colourSel.value = l.c;
        Object.keys(l.q).forEach(function (k) { var i = sizesEl.querySelector('input[data-size="' + (window.CSS && CSS.escape ? CSS.escape(k) : k) + '"]'); if (i) i.value = l.q[k]; });
        updateSub(); sel.focus();
      });
    });
    // Serialize for the email + sync the other fields.
    field.value = lines.length ? lines.map(function (l) {
      var p = byHandle[l.h];
      return p.t + (l.c ? ' (' + l.c + ')' : '') + ' — ' + Object.keys(l.q).map(function (k) { return sizeText(p, k) + ' × ' + l.q[k]; }).join(', ') + ' [' + unit(p, sum(l.q)) + ']';
    }).join('\n') + '\nTOTAL: ' + totalText : '';
    if (pairsInput && lines.length && pairs + items) pairsInput.value = pairs + items;
    if (rangeSel && lines.length) {
      var rs = Object.keys(rangeSet), want = rs.length === 1 ? rs[0] : t('mix', 'A mix');
      Array.prototype.forEach.call(rangeSel.options, function (o) { if (o.value === want || o.text === want) rangeSel.value = o.value; });
    }
    if (notes) {
      notes.required = !lines.length;
      if (notesLabel) notesLabel.firstChild.textContent = lines.length ? t('notes_more', 'Anything else we should know? (optional)') : notesLabelText;
      notes.placeholder = lines.length ? t('notes_more_ph', 'e.g. delivery date, branding, or styles you couldn’t find') : notesPh;
    }
  }

  sel.addEventListener('change', function () { var next = sel.value; add(); pick(next); }); // keep quantities typed for the previous product
  addBtn.addEventListener('click', add);
  sizesEl.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); add(); } });
  var submitBtn = form.querySelector('[type=submit]');
  if (submitBtn) submitBtn.addEventListener('click', function () { add(); }); // before browser validation
  form.addEventListener('submit', function (e) {
    add(); // include quantities typed but not yet added
    if (!lines.length && notes && !notes.value.trim()) { e.preventDefault(); errEl.hidden = false; sel.focus(); }
  });

  // Show the builder (the plain textarea stays as the no-JS fallback).
  root.hidden = false;
  if (notesLabel) notesLabel.firstChild.textContent = notesLabelText = t('notes_describe', 'Or describe what you need');
  // Successful submit → clear the saved list.
  if (form.querySelector('.v2-note--ok')) { lines = []; save(); }
  render();

  // Arriving from a product page: ?product=<handle>&size=<size>
  var q = new URLSearchParams(location.search);
  if (q.get('product') && byHandle[q.get('product')]) {
    pick(q.get('product'));
    var focusIt = function () {
      var s = q.get('size'), inp = s && sizesEl.querySelector('input[data-size="' + (window.CSS && CSS.escape ? CSS.escape(s) : s) + '"]');
      inp = inp || sizesEl.querySelector('input');
      if (inp) { inp.closest('.v2-qb__size').classList.add('is-suggested'); inp.focus({ preventScroll: true }); root.scrollIntoView({ block: 'start' }); }
    };
    if (document.readyState === 'complete') setTimeout(focusIt, 150); else window.addEventListener('load', function () { setTimeout(focusIt, 150); });
  }
})();
